import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "banner-container" }
const _hoisted_2 = {
  key: 0,
  class: "overlay"
}

import { default as ColourPicker } from '@/shared/services/color';
import { PropType } from 'vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'Banner',
  props: {
  showOverlay: {
    type: Boolean,
  },
  type: {
    type: String as PropType<'warning' | 'info'>,
    default: 'warning',
  },
},
  setup(__props) {

const props = __props;

function getContrastingColour() {
  let bgColour = '#91B2ff';
  if (props.type === 'warning') {
    bgColour = '#E6C300';
  }
  return ColourPicker.getContrastingColour(bgColour);
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: _normalizeClass(["banner", { info: __props.type === 'info' }]),
      style: _normalizeStyle({ color: getContrastingColour() })
    }, [
      _renderSlot(_ctx.$slots, "default")
    ], 6),
    _createVNode(_Transition, { name: "fade" }, {
      default: _withCtx(() => [
        (__props.showOverlay)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2))
          : _createCommentVNode("", true)
      ]),
      _: 1
    })
  ]))
}
}

})